import React from 'react';
import OrderList from '../../components/orders/OrderList';

const Orders: React.FC = () => {

    return (<div>
        <OrderList />
    </div>)
};

export default Orders;